import { EntityReference, ShoppingSessionReference } from '../../core/api/api.entities';
import { FormOptions } from './base.form-options';

export class ShoppingSessionFormOptions extends FormOptions {
  shoppingSessions: ShoppingSessionReference[] = [];
  stores: EntityReference[] = [];
}
